import { DatabasesByTagQuery } from '../../../../../../gen-src/queries';
import {
  getMaxDownstreamDatasources,
  getMaxDownstreamWorkbooks,
  MaxCountsResultData
} from '../../../../data-catalog-shared';
import { DenormalizedDatabaseRowData } from '../types/DatabasesDisplayGridRowData';

export function getRowDataWithMaxCountsForDatabase<D>(
  database: D,
  resultData: MaxCountsResultData | null,
): D & DenormalizedDatabaseRowData {
  return {
    ...database,
    contentType: 'database',
    maxDownstreamDatasources: getMaxDownstreamDatasources(resultData),
    maxDownstreamWorkbooks: getMaxDownstreamWorkbooks(resultData),
  };
}

export function getRowDataWithMaxCountsForDatabaseWithTagFilter<D>(
  database: D,
  resultData: DatabasesByTagQuery | null,
): D & DenormalizedDatabaseRowData {
  const tag = resultData && resultData.tags && resultData.tags[0];
  return getRowDataWithMaxCountsForDatabase(database, tag);
}
